const getFacilityCityState = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Address'] && facility['Company Address'].ID) {
    return `${facility['Company Address'].City}, ${facility['Company Address'].State}`.toUpperCase();
  }
  return null;
};

export default getFacilityCityState;


// WEBPACK FOOTER //
// ./src/utils/print/getFacilityCityState.js